// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jh-6";
export var emphasizeQuantity = "_jh-3";
export var flatBottomCorners = "_jh-5";
export var productImage = "_jh-0";
export var quantityContainer = "_jh-2";
export var tooltip = "_jh-1";
export var wrapAndEllipsesOverflow = "_jh-4";